import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["button", "secondaryButton"];

  connect() {
    this.load();
  }

  load() {
    fetch(this.urlValue, { credentials: "include" })
      .then((response) => response.json())
      .then(({ user }) => {
        if (user) {
          this.secondaryButtonTarget.classList.remove("hidden");
          this.render(user);
        }
      })
      .catch((error) => {
        console.error("Could not access Raspberry Pi ID API", error);
      });
  }

  render({ name, email, image }) {
    const img = document.createElement("img");
    img.className = "h-10 w-10 rounded-full border-2 border-white shadow-sm";
    img.src = image;

    const container = document.createElement("div");
    container.className = "grow space-y-1";

    const nameContainer = document.createElement("div");
    nameContainer.className = "font-bold text-normal leading-none";
    nameContainer.innerText = `Sign in as ${name}`;
    container.appendChild(nameContainer);

    const emailContainer = document.createElement("div");
    emailContainer.className = "font-normal text-xs leading-none";
    emailContainer.innerText = email;
    container.appendChild(emailContainer);

    this.buttonTarget.classList.add("pl-1", "space-x-2", "min-w-[240px]");
    this.buttonTarget.innerHTML = "";
    this.buttonTarget.appendChild(img);
    this.buttonTarget.appendChild(container);
  }
}
